/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

export default function Switch({
  value,
  onChange,
  options,
  variant = 'standard',
  ...rest
}) {
  let className =
    variant === 'standard'
      ? css`
          align-items: center;
          flex-shrink: 0;
          & .MuiTabs-flexContainer {
            width: fit-content;
            border-radius: 64px !important;
            border: 1px solid #0000001f;
          }
          & button {
            border-radius: 64px !important;
            font-size: 13px;
            font-weight: 600;
            line-height: 22px;
            padding: 12px;
            min-height: 34px;
            max-height: 34px;
          }
          & *[aria-selected='true'] {
            color: #fff !important;
            background: var(--primary-main);
          }
          & *[aria-selected='false'] {
            color: rgba(0, 0, 0, 0.54);
          }
          & .MuiTabs-indicator {
            display: none;
          }
        `
      : css`
          //outlined version
          align-items: center;
          flex-shrink: 0;
          & .MuiTabs-flexContainer {
            width: fit-content;
            border-radius: 64px !important;
            border: 1px solid rgba(32, 40, 250, 0.3);
            background: #dce8ff;
          }
          & button {
            border-radius: 64px !important;
            font-size: 13px;
            font-weight: 600;
            line-height: 22px;
            padding: 12px;
            min-height: 34px;
            max-height: 34px;
          }
          & *[aria-selected='true'] {
            color: #fff !var(--primary-main);
            background: white;
            border: 2px solid var(--primary-main);
            font-weight: 600;
          }
          & *[aria-selected='false'] {
            color: #151851;
            font-weight: 400;
          }
          & .MuiTabs-indicator {
            display: none;
          }
        `;

  return (
    <Tabs value={value} onChange={onChange} css={className} {...rest}>
      {options.map((option) => (
        <Tab
          key={option.value}
          label={option.label}
          value={option.value}
          icon={option.icon}
          iconPosition="start"
        />
      ))}
    </Tabs>
  );
}
